import AssistanceAdjustList from "../../components/AssistanceAdjustList/AssistanceAdjustList";
import Calendar from "../../components/Calendar/Calendar";
import { AnimatePresence, motion } from "framer-motion";
import { createContext, useState } from "react";
import { AppState } from "../../store/reducer";
import "../../../src/views/Home/Home.scss";
import { useSelector } from "react-redux";
import { Box } from "@mui/material";

export const AssistanceAdjustContext = createContext<any>({
	setSelected: () => {},
	selected: Date,
});

export default function AssistanceAdjust() {
	const [selected, setSelected] = useState<Date>(new Date());

	const viewFullCalendar: boolean = useSelector((state: AppState) => state.viewFullCalendar);

	return (
		<>
			<AssistanceAdjustContext.Provider
				value={{
					setSelected,
					selected,
				}}
			>
				<AnimatePresence initial={false}>
					<Box className="home__body">
						<motion.div
							className="home__body__calendar"
							transition={{
								duration: 1.0,
								ease: "easeInOut",
							}}
							animate={
								viewFullCalendar ? { flexBasis: "100%" } : { flexBasis: "20rem" }
							}
						>
							<Calendar viewFullCalendar={viewFullCalendar} />
						</motion.div>

						<motion.div
							className="home__body__list"
							transition={{
								duration: 1.0,
								ease: "easeInOut",
							}}
							animate={viewFullCalendar ? { opacity: 0, width: 0 } : { opacity: 1 }}
						>
							<AssistanceAdjustList />
						</motion.div>
					</Box>
				</AnimatePresence>
			</AssistanceAdjustContext.Provider>
		</>
	);
}
